document.addEventListener("DOMContentLoaded", () => {

  // 判断用户积分的等级阶段
  function pointsJudge() {
    var customerPoints = $(".information_value .sweettooth-points-balance").text().trim();
    let isLastItemProcessed = false;

    if (customerPoints.length != 0) {
      var levelData = $(".customer_level_information").attr("data-array");
      var levelArray = "";

      $('.points_tips_num').css('display', 'block')

      try {
        levelArray = JSON.parse(levelData);
      } catch (error) {
        console.error("Failed to parse JSON:", error);
      }

      for (const item of levelArray) {
        const level = item.level;
        const num = parseInt(item.num, 10);
        if (customerPoints < num) {
          $(".current_level_num").text(num);
          $(".customer_level .information_value").text(level);
          var needPoint = num - customerPoints;
          $(".need_points").text(needPoint);
          var barWidth = (customerPoints / num * 100) + '%'
          $('.points_bar_active').css('width', barWidth)
          break;
        }

        if (levelArray.indexOf(item) === levelArray.length - 1 && customerPoints > parseInt(levelArray[levelArray.length - 1].num, 10)) {
          isLastItemProcessed = true;
        }
      }

      if (isLastItemProcessed) {
        $(".current_level_num").text('1001+ points')
        $('.customer_level .information_value').text('Dragon')
        $('.points_bar_active').css('width', '100%')
        $('.points_tips_text').text('Your points expire soon. Redeem them now!')
      }

    }
  }

  // 检测插件积分加载
  const $target = $(".information_value .sweettooth-points-balance");
  if ($target.length) {
    const observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList" || mutation.type === "characterData") {
          pointsJudge()
          break;
        }
      }
    });

    const config = {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true,
    };

    observer.observe($target[0], config);
  }

});
